module.exports = __webpack_public_path__ + "img/visa-disabled.bc9afbf0.svg";